import React, { useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Home.css"; // Ensure this CSS file is updated
import AboutUsSlider1 from "../assets/img/AboutUsSlider1.png";
import AboutUsSlider2 from "../assets/img/AboutUsSlider2.png";
import AboutUsSlider3 from "../assets/img/AboutUsSlider3.png";
import AboutUsSlider4 from "../assets/img/OurServicesImage2.png";
import AboutUsSlider5 from "../assets/img/OurServicesImage3.png";

const FeatureCard = ({ icon, title, description, img }) => {
  return (
    <div className="col-md-2 d-flex justify-content-center" data-aos="fade-up">
      <div className="feature-card">
        <div className="feature-card-inner">
          {/* Front Side with Background Image */}
          <div
            className="feature-card-front"
            style={{ backgroundImage: `url(${img})` }}
          >
            <div className="overlay"></div>
            <div className="content">
              <h5 className="text-white fw-bold">{title}</h5>
            </div>
          </div>

          {/* Back Side with Yellow Background */}
          <div className="feature-card-back">
            <div className="content">
              <i className={`bi ${icon} feature-icon`}></i>
              <p className="text-light fw-bold">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Services = () => {
  const features = [
    {
      title: "Bringing the stakeholders in one common platform",
      description: "To unite all stakeholders in the pulses value chain",
      img: AboutUsSlider1,
    },
    {
      title: "Defining a long-term vision and identification of gaps",
      description:
        "To set a long-term vision and identify gaps across the entire value chain of pulses",
      img: AboutUsSlider2,
    },
    {
      title: "Enhancing market access plans",
      description:
        "To improve market access for pulses producers and businesses.",
      img: AboutUsSlider3,
    },
    {
      title: "Dissemination of information & policy advocacy",
      description:
        "To share information and advocate for policies that support the pulses industry",
      img: AboutUsSlider4,
    },
    {
      title: "Increase value of Pulses",
      description: "Enhancing pulses market value",
      img: AboutUsSlider5,
    },
  ];

  return (
    <div className="container-services text-center py-5">
      <h2 className="separator-title" style={{ color: "#d4561a" }}>
        Our Objectives
      </h2>
      <div className="separator-line"></div>
      <p className="section-subtitle fw-bold mt-3">What We Value The Most</p>
      <div className="row justify-content-center gap-3">
        {features.map((feature, index) => (
          <FeatureCard key={index} {...feature} />
        ))}
      </div>
    </div>
  );
};

export default Services;
